export const DEFAULT_PRICE_CLASS = 'gray' as const;
export const LOW_PRICE_CLASS = 'green' as const;
export const MEDIUM_PRICE_CLASS = 'amber' as const;
export const HIGH_PRICE_CLASS = 'red' as const;
export const PRICE_CLASSES = [
  LOW_PRICE_CLASS,
  MEDIUM_PRICE_CLASS,
  HIGH_PRICE_CLASS,
] as const;
export const NUMBER_OF_PRICE_BANDS = 3 as const;
export const LOW_MEDIUM_BOUNDARY = 0.4 as const;
export const MEDIUM_HIGH_BOUNDARY = 0.7 as const;
export const PRICE_BAND_BOUNDARIES = [
  LOW_MEDIUM_BOUNDARY,
  MEDIUM_HIGH_BOUNDARY,
] as const;
export const HOTEL_PRICE_DIRECTION_CHEAP = 'CHEAP' as const;
export const HOTEL_PRICE_DIRECTION_MODERATE = 'MODERATE' as const;
export const HOTEL_PRICE_DIRECTION_EXPENSIVE = 'EXPENSIVE' as const;

export const priceBandConstants = {
  DEFAULT_PRICE_CLASS,
  LOW_PRICE_CLASS,
  MEDIUM_PRICE_CLASS,
  HIGH_PRICE_CLASS,
  PRICE_CLASSES,
  NUMBER_OF_PRICE_BANDS,
  LOW_MEDIUM_BOUNDARY,
  MEDIUM_HIGH_BOUNDARY,
  PRICE_BAND_BOUNDARIES,
  HOTEL_PRICE_DIRECTION_CHEAP,
  HOTEL_PRICE_DIRECTION_MODERATE,
  HOTEL_PRICE_DIRECTION_EXPENSIVE,
} as const;
